<footer id="footer">
  <div class="container">
    <div class="ntc-info">
      <a class="link" href="https://www.netcomm.com">
        <img [src]="logoUrl" [style.width]="logoWidth" [style.height]="logoHeight" alt="Company logo">
      </a>
    </div>
    <div class="clearfix"></div>
    <div class="copyright">
      &copy; LANTRONIX, INC. {{ currentYear }}. ALL RIGHTS RESERVED. | <a href="https://www.lantronix.com/legal/" target="_blank" rel="noopener noreferrer">Privacy
        Policy</a>
    </div>
  </div>
</footer>

